import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import { AppShell } from "@/components/layout/AppShell";
import { Spinner } from "@/components/ui";
import Home from "./pages/Home";
import Login from "./pages/Login";
import OcrLab from "./pages/OcrLab";
import PdfLab from "./pages/PdfLab";
import PdfLabRuns from "./pages/PdfLabRuns";
import Runs from "./pages/Runs";

interface User { name: string; email?: string }

export default function App() {
  const [user, setUser] = useState<User | null | undefined>(undefined);

  useEffect(() => {
    fetch("/api/auth/session", { credentials: "include" })
      .then((r) => r.json())
      .then((d) => setUser(d.user))
      .catch(() => setUser(null));
  }, []);

  // `undefined` = still checking. Rendering the login page during the check
  // would flash sign-in at users who are already signed in.
  if (user === undefined) {
    return (
      <div className="grid min-h-screen place-items-center bg-fh-surface-soft">
        <Spinner />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
        {user ? (
          <Route element={<AppShell user={user} />}>
            <Route path="/" element={<Home />} />
            <Route path="/ocrlab" element={<OcrLab />} />
            <Route path="/ocrlab/runs" element={<Runs />} />
            <Route path="/pdflab" element={<PdfLab />} />
            <Route path="/pdflab/runs" element={<PdfLabRuns />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}
